// extracted by mini-css-extract-plugin
var _1 = "appContent-LS0m";
export { _1 as "appContent" }
